import dayjs from 'dayjs';

export const MINUTES_IN_DAY = 24 * 60;

// labelled every 2 hours, 00 to 24
export const AXIS_HOURS = [...new Array(13)].map((_, i) => i * 2);

export const minutesOfDay = (date) => {
  const d = dayjs(date);
  return d.diff(d.startOf('day'), 'minutes');
};

// horizontal position on a 24h track, as a CSS percentage
export const dayPercent = (minutes) => `${(minutes / MINUTES_IN_DAY) * 100}%`;
